<template>
    <div id="app">

    <v-app id="inspire">
    <template v-if="isDisplayMenu">

        <div class="main">
          <toolbar :activeLinkName="linkName"/>

          <div class="adaptive">
            <transition name="page">
              <router-view />
            </transition>
          </div>
        </div>
    </template>

    <template v-else>
      <router-view v-if="showComponent"></router-view>
    </template>
</v-app>
    </div>
</template>

<script>
    import Mgr from './services/SecureService';
    import { mapGetters } from 'vuex';
    import axios from 'axios'
    import API from './services/apiService.js'
    import hub from "./signalRHub"


    var api= new API();

    export default {
        name: 'App',
        data () {
            return {

                mgr:new Mgr(),
                showComponent:true,
                linkName:null,
                user:null,
            }
        },
        mounted () {
            var vm=this;
            if(this.$route.path=="/callback"||this.$route.path.indexOf("/Error/")!=-1)
            {
                this.showComponent=true;
            }
            else {
                //если есть в сторе, то берем оттуда
                if (this.$store.state.userData.curUser != null) {
                    this.$store.commit("userData/setSignedIn", true);
                    //добавляем токен ко всем запросам
                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.userData.curUser.access_token
                    //получаем информацию о пользователе
                    if (this.$store.state.userData.webUser == null) {
                        var getparams = '?Id=' + this.$store.state.userData.curUser.profile.sub;
                        api.Get("UserService/WebUser/GetById" + getparams).then(data => this.$store.commit("userData/setWebUserInfo", data))
                    }
                    const vm = this;
                    //подключаемся к хабу
                    if (this.$root.connection == null) {
                        this.$root.connection = hub.createHub(vm.$store.state.userData.curUser.access_token)
                        this.$root.connection.start().then(() => console.info("connected to hub"))
                            .catch(err => console.error(err));
                        this.$root.connection.on("SendMessageToUser", param=>{
                            this.takeMessageHandle(param)
                        })

                        this.$root.connection.on("SendMessageToGroup", param=>{
                            this.takeRequestHandle(param)
                        })

                    }
                }
                else
                    this.mgr.getUser().then(
                        user => {
                            if (user) {
                                this.$store.commit("userData/setSignedIn", true);
                                this.$store.commit("userData/setCurUser", user);
                                //добавляем токен ко всем запросам
                                axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token

                                //получаем информацию о пользователе
                                var getparams = '?Id=' + user.profile.sub;
                                api.Get("UserService/WebUser/GetById" + getparams).then(data => this.$store.commit("userData/setWebUserInfo", data))

                                if (this.$root.connection == null) {
                                    this.$root.connection = hub.createHub(user.access_token)
                                    this.$root.connection.start().then(() => console.info("connected to hub"))
                                        .catch(err => console.error(err));

                                    this.$root.connection.on("SendMessageToUser", param=>{
                                        this.takeMessageHandle(param)
                                    })

                                    this.$root.connection.on("SendMessageToGroup", param=>{
                                        this.takeRequestHandle(param)
                                    })
                                }

                            }
                            else {
                                this.$store.commit("userData/setSignedIn", false);
                                this.$store.commit("userData/setCurUser", null);
                                vm.user = null;
                            }
                        },
                        err => {
                            console.log(err)
                        }
                    )
            }
        },

        computed:{
            ...mapGetters({
                isSignedIn:"userData/isAuthenticated",
                getChatUser: "Chats/getChatUser",
                getRequestById:"Requests/getRequestById",
                menuItemsForRole: "userData/getMenuItems",
            }),

            isDisplayMenu(){
                if(this.$route.path=="/callback"||this.$route.path.indexOf("/Error/")!=-1)
                    return false;
                else
                    return this.isSignedIn;
            },
        },

        methods: {
            takeMessageHandle(param){
                if(param!=null) {
                    var mesModel = {
                        chatMessageId: param.chatMessageId,
                        isClient: param.isClient,
                        chatId: param.chatId,
                        message: param.message,
                        messageDate: param.messageDate,
                        requestAnswerId:null
                    }
                    //добавить уведомление
                    var params= {
                        message:mesModel,
                        CountNotReadChatMessage:param.countNotReadMessage

                    }
                    const vm= this;
                    this.$store.dispatch("Chats/putMessage", params).then(()=>{
                        //получить данные чата для всплывашки
                        var chatInfo= this.getChatUser(param.chatId)
                        if(chatInfo!=null&&vm.$route.path!="/ClientSupport"){
                            this.$store.dispatch("Notifications/addNotification", 1).catch(e=>{
                                console.log("Ошибка добавления уведомления")
                            });
                            this.$bvToast.toast(param.message, {
                                title: `Сообщение от ${chatInfo.clientName}`,
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 5000,
                                appendToast:true,
                                solid: true
                            })
                        }
                    })
                }
                console.log(param);
            },

            takeRequestHandle(param){
                //загрузить данные заявки в стор
                this.$store.dispatch("Requests/getBySignalR", param.requestId).then(()=>{
                    //добавить в уведомления
                    var reqData= this.getRequestById(param.requestId);
                    console.log("Заявка от signalR:");
                    console.log(reqData);
                    if(reqData!=null){
                        this.$store.dispatch("Notifications/addNotification", 0);
                        //отобразить всплывающее сообщение
                        this.$bvToast.toast(reqData.requestText, {
                            title: `Новая заявка от ${reqData.clientFullName}`,
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 3000,
                            solid: true
                        })
                    }
                });

                console.log(param);
            }
        },
        watch: {
            '$route' (to, from) {

                var vm=this;
                /*if(to.name=="Main")
                if (this.$store.state.userData.curUser!= null) {
                    let menuItems=  this.$store.state.userData.menuItems//this.menuItemsForRole(this.$store.state.userData.curUser.profile.role);
                    if(menuItems!=null){}
                    this.$router.push({name: menuItems[0].name})
                    return
                }*/

                if(this.$route.path=="/callback"||this.$route.path.indexOf("/Error/")!=-1)
                {
                    this.showComponent=true;
                }
                else {
                    this.linkName=to.name;
                    //если есть в сторе, то берем оттуда
                    if (this.$store.state.userData.curUser != null) {
                        this.$store.commit("userData/setSignedIn", true);
                        //добавляем токен ко всем запросам
                        axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.userData.curUser.access_token
                        this.$store.dispatch("userData/getMenuItems")
                        //получаем информацию о пользователе
                        if (this.$store.state.userData.webUser == null) {
                            var getparams = '?Id=' + this.$store.state.userData.curUser.profile.sub;
                            api.Get("UserService/WebUser/GetById" + getparams).then(data => this.$store.commit("userData/setWebUserInfo", data))
                        }

                        //подключаемся к хабу
                        if (this.$root.connection == null) {
                            this.$root.connection = hub.createHub(vm.$store.state.userData.curUser.access_token)
                            this.$root.connection.start().then(() => console.info("connected to hub"))
                                .catch(err => console.error(err));
                            this.$root.connection.on("SendMessageToUser", param=>{
                                this.takeMessageHandle(param)
                            })

                            this.$root.connection.on("SendMessageToGroup", param=>{
                                this.takeRequestHandle(param)
                            })

                        }
                    }
                    else
                        this.mgr.getUser().then(
                            user => {
                                if (user) {
                                    this.$store.commit("userData/setSignedIn", true);
                                    this.$store.commit("userData/setCurUser", user);
                                    //получаем инфу о пользователе
                                    //добавляем токен ко всем запросам
                                    axios.defaults.headers.common['Authorization'] = 'Bearer ' + user.access_token
                                    vm.user = user;
                                }
                                else {
                                    this.$store.commit("userData/setSignedIn", false);
                                    this.$store.commit("userData/setCurUser", null);
                                    vm.user = null;
                                }
                            },
                            err => {
                                console.log(err)
                            }
                        )
                }
            }
        }

    }
</script>

<style>

    #app hr{
        margin: 0;
    }

    input.phone + label.phone:before {
        content: attr(data-fon);
        position: absolute;
        left: 7px;
        top:34px;
        font-weight: 400;
        line-height: 1.5;
        color: #495057;
    }

    input.phone{
        display: inline-block;
        padding-left: 35px;
        vertical-align: middle;
    }


    .disabled-filled-option{
        background: #F5F7FD;
        border: 1px solid #FFFFFF;
        box-sizing: border-box;
        border-radius: 4px;
        padding: 5px 5px 5px 10px;
        font-style: normal;
        font-size: 16px;
        line-height: 20px;
        color:black;
        min-height: 40px;
    }

    footer.modal-footer{
        background-color: #EFF2FC !important;
    }

    .card-container.v-card {
        height: 100%;
        max-height: 100%;
        display: flex;
        flex-direction: column;
    }

    .custom-input-label{
        color:var(--color-2);
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        vertical-align: middle;
    }
    .cancel-btn:hover{
        color:var(--color-2) !important;
    }

    .custom-group-label{
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
        vertical-align: middle;
        color: black;
    }

    .custom-group-label.custom-label-disabled{
        color:var(--color-3);
        font-weight: 500;
    }

    .underlined-tab.v-tab{
        border-bottom: 2px solid var(--color-3);
        text-transform: capitalize;
    }

    .v-list-item:hover{
        background-color: #fafafa;
    }

    .bonus-container{
        padding: 3px;
        width: 105px;
        border: 2px solid;
        text-align: center;
    }

    .bonus-container>div{
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        text-align: center;
        text-transform: uppercase;
    }


    .bonus-1{
        border-image-source: linear-gradient(90deg, #004994 0%, #6BB5FF 100%);
        border-image-slice: 1;
    }
    .bonus-1>div{
        color: #347DC8;
    }

    .bonus-2{
        border-image-source: linear-gradient(270deg, #CCD7EA 0%, #7E7B8D 106.54%);
        border-image-slice: 1;
    }
    .bonus-2>div{
        color: #989AAC;
    }

    .bonus-3{
        border-image-source: linear-gradient(270deg, #FFE176 0%, #B78F00 100%);
        border-image-slice: 1;
    }
    .bonus-3>div{
        color: #CAA41E;
    }

    .bonus-0{
        border:none;
    }
    .bonus-0>div{
        color: #3E4F5C;
        font-weight: 500;
    }
    .client-st1{
        color:#7E7B8D;
    }

    .client-st2{
        color:green;
    }

    .client-st4{
        color: #CAA41E;
    }

    .mark-required{
        color:red;
    }

</style>

<style lang="scss">
@import './styles/variables.scss';
:root {
    --color-blue:#0156AD;
    --color-red: #EB5757;
    --text-color:#1A2A3A;
    --color-1:#3E4F5C;
    --color-2:#6E7C8D;
    --color-3: #ACB7C0;
    --color-4:#D3DAE1;
    --color-5:#EFF2FC;
}

  #inspire {
      background-color: #FAFAFA;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
      height: 100vh;

  }
  .main{
        padding-top:70px;
        height: 100%;
        width: 100%;
        color: var(--text-color);
    }

  .main>div>.container.dictionary-page{
      padding-top:50px;
  }

    .adaptive {
        width: 80%;
        height: 100%;
        margin: 0 auto;
    }

  .sticky{
    position: sticky;
    top: 100px;
    min-height: 2em;
    z-index: 1;
    background-color: rgb(238, 242, 255);
  }

  .table, .b-table{
    background-color: #fff;
  }

  .page-enter-active {
    transition: opacity .7s;
  }

  .page-enter, .page-leave-to {
    opacity: 0;
  }

.v-application .primary{
    background-color: var(--color-5) !important;
    border:none !important;
}



.btn{
    border-radius: 4px;
}

.btn-primary:hover, .btn-primary:active {
    color: #036DDA;
}
.btn-outline-primary:not(.active):not(:hover){
    color: var(--color-2) !important;
    border:none !important;
}

.custom-tabs.theme--light.v-tabs>.v-tabs-bar{
    background-color: #fafafa !important;
}
.custom-tabs.theme--light.v-tabs>.v-tabs-bar>.v-slide-group__wrapper >div>.v-tab{
    text-transform: capitalize;

}

.subheader-strong-label{
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color:black;
}

.subheader-label{
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color:var(--color-2);
}
@media (max-width: 992px) {
    .adaptive {
        width: 100%;
        height: 100%;
        margin: 0 auto;
    }
    .main{
        padding-top: 0;
    }
}

</style>
